/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Style_Guide_Errors_Count_Aria_LabelInputs */

const en_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} errors found`)
};

const fr_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} erreurs trouvees`)
};

const de_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Fehler gefunden`)
};

const it_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} errori trovati`)
};

const ru_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} обнаружены ошибки`)
};

const es_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} errores encontrados`)
};

const zh_cn2_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`发现${i?.count}错误`)
};

const ja_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} エラーが見つかりました`)
};

const hi_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} त्रुटियाँ पाई गईं`)
};

const pt_pt2_style_guide_errors_count_aria_label = /** @type {(inputs: Style_Guide_Errors_Count_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erros ${i?.count} encontrados`)
};

/**
* | output |
* | --- |
* | "{count} errors found" |
*
* @param {Style_Guide_Errors_Count_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_errors_count_aria_label = /** @type {((inputs: Style_Guide_Errors_Count_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Errors_Count_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_errors_count_aria_label(inputs)
	if (locale === "de") return de_style_guide_errors_count_aria_label(inputs)
	if (locale === "it") return it_style_guide_errors_count_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_errors_count_aria_label(inputs)
	if (locale === "es") return es_style_guide_errors_count_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_errors_count_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_errors_count_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_errors_count_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_errors_count_aria_label(inputs)
	return en_style_guide_errors_count_aria_label(inputs)
});